import * as React from 'react';
import { Query } from '@apollo/client/react/components';

import { ONBOARDING_GETINDEXABLEFILESFORPLANT_QUERY } from '../../../api/GraphQLQueries/Onboarding';
import IPlantModel from '../../../models/IPlantModel';
import Loading from '../../../components/layout/Loading';
import { notification } from '../../../utils/notification';
import PlantOnboarding from './PlantOnboarding';

interface IProps {
    plant: IPlantModel;
    refetch?: () => void;
}

export default class PlantOnboardingQuery extends React.Component<IProps> {
    public render = () => {
        const { plant, refetch: refetchPlant } = this.props;

        return (
            <Query
                query={ONBOARDING_GETINDEXABLEFILESFORPLANT_QUERY}
                variables={{ plantS3Folder: plant.s3Folder }}
                fetchPolicy="network-only"
            >
                {({ data, loading, error, refetch }) => {
                    if (loading) {
                        return <Loading />;
                    }
                    if (error) {
                        notification.error(
                            'Something went wrong while retreiving files to be indexed. Please try again later',
                        );
                        return <></>;
                    }

                    const {
                        s3FileCount,
                        indexables,
                        partsCsv,
                        documentumCsvExists,
                    } = data.getIndexableFilesForPlant;
                    return (
                        <>
                            <PlantOnboarding
                                plant={plant}
                                s3FileCount={s3FileCount}
                                partsCsv={partsCsv}
                                documentumCsvExists={documentumCsvExists}
                                indexables={indexables}
                                refetch={refetch}
                                refetchPlant={refetchPlant}
                            />
                        </>
                    );
                }}
            </Query>
        );
    };
}
